/*
* User avatar, name, dropdown for top nav bar
*/

import * as React from 'react';
import * as _ from 'lodash';

import Auth from '../auth/auth';
import { NavLinkComponent, NavigationLinks } from '../common/navigation';

export interface INavUserInfoProps extends Partial<any> {
    authUser?: any;
}

export default class NavUserInfo extends React.Component<INavUserInfoProps, any> {
    public readonly messagesPathPrefix: string = 'app.nav-user-info.';

    public constructor(props: INavUserInfoProps) {
        super(props);
    }

    public handleLogout() {
        const auth = new Auth();
        auth.logout(auth.getCurrentViewPath());
    }

    public appText(messagePath: string, prependMessagesPathPrefix: boolean = true, tokenValue: string = ''): string {
        // Return branded app text, based on partial intl.messages path token suffix. Auto concat'ed with this.messagesPathPrefix
        let result = '';
        if (!messagePath || !this.messagesPathPrefix || !this.props.intl || !this.props.intl.messages) { return result; }
        const path = prependMessagesPathPrefix ? `${this.messagesPathPrefix}${messagePath}` : messagePath;

        result = _.get(this.props.intl.messages, path);

        if (result === undefined) {
            // console.log(`ERROR: app-component-base.t: Undefined message for token path "${path}".`);
            result = '';
        }

        const re = /{TOKEN_VALUE}/gi;
        result = result.replace(re, tokenValue);

        return result;
      }

    public render() {
        const { authUser, branding, ...rest } = this.props;        

        return (
            <li className="dropdown">
                <a className="dropdown-toggle profile-pic" data-toggle="dropdown" aria-expanded={false} href="#">
                    <img src={branding.defaultAvatar} alt="user-img" className="nav-profile-pic img-circle" />
                    <b className="hidden-xs">{authUser.userFullName}</b>
                    <span className="caret" />
                </a>
                <ul className="dropdown-menu dropdown-user">
                    <li>
                        <div className="dw-user-box">
                            <div className="u-img">
                                <img src={branding.defaultAvatar} alt={authUser.username} />
                            </div>
                            <div className="u-text truncate">
                                <h5 className="truncate"><strong>{authUser.userFullName}</strong></h5>
                                <p className="text-muted truncate">{authUser.email}</p>
                                {/* <NavLinkComponent
                                    caption={this.appText('view-profile')}
                                    omitWrapper={true}
                                    linkDetails={{ className: 'btn btn-rounded btn-danger btn-xs', to: NavigationLinks.myAccount(authUser.userObjId) }}
                                >
                                    {this.appText('view-profile')}
                                </NavLinkComponent> */}
                            </div>
                        </div>
                    </li>
                    <li role="seperator" className="divider" />
                    <li className="dropdown-user-box-li">
                        <NavLinkComponent caption={this.appText('my-profile')} omitWrapper={true} linkDetails={{ to: NavigationLinks.myAccount(authUser.userObjId) }}>
                            <i className="fa fa-user" /> {this.appText('my-profile')}
                        </NavLinkComponent>
                    </li>
                    <li role="seperator" className="divider" />
                    <li className="dropdown-user-box-li">
                        <a href="#" onClick={e => { this.handleLogout(); }}>
                            <i className="fa fa-power-off" /> {this.appText('logout')}
                        </a>
                    </li>
                </ul>
            </li>
        );
    }
}



// WEBPACK FOOTER //
// ./src/applayout/nav-userinfo.tsx